'use client';
import { ListboxOption } from '../listbox/listbox-option.component.js';

const MenuItem = ListboxOption;
ListboxOption.displayName = 'MenuItem';

export { MenuItem };
